import React from 'react';
import { Card, Grid } from 'ui-toolkit/components';
import { LabelValueViewer } from '../shared/LabelValueViewer';
import { humanizeEndorsement } from 'utilities/shared/stringMethods/humanizeEndorsement';
import { TransactionTypesViewer } from '../shared/TransactionTypesViewer';
import { IPolicyCalcEndorsementConfigData } from 'types/administration/pricing/underwriterProfileInterfaces/IPolicyCalcEndorsementConfig';
import { eEndorsementNames, TemplateEndorsementsViewer } from './TemplateEndorsementsViewer';

interface IPolicyCalcEndorsementsViewerProps {
  policyCalcEndorsements: IPolicyCalcEndorsementConfigData[];
}

export const PolicyCalcEndorsementsViewer: React.FC<IPolicyCalcEndorsementsViewerProps> = ({
  policyCalcEndorsements,
}) => (
  <TemplateEndorsementsViewer endorsementName={eEndorsementNames.PolicyCalc} endorsements={policyCalcEndorsements}>
    {policyCalcEndorsements.map((endorsement, index) => (
      <Card key={endorsement.endorsementType} title={index + 1} isCollapsible>
        <Grid columnCount={2}>
          <LabelValueViewer
            label={'Endorsement'}
            value={humanizeEndorsement(endorsement.endorsementType)}
            templateColumns={'1fr 1fr'}
          />
          <LabelValueViewer label={'Policy Type'} value={endorsement.policyType} templateColumns={'1fr 1fr'} />
          <LabelValueViewer label={'Minimum'} value={endorsement.minimum} templateColumns={'1fr 1fr'} />
          <LabelValueViewer
            label={'Percent of Policy'}
            value={endorsement.percentOfPolicy}
            templateColumns={'1fr 1fr'}
          />
        </Grid>
        <TransactionTypesViewer transactionTypes={endorsement.transactionTypes} />
      </Card>
    ))}
  </TemplateEndorsementsViewer>
);
